Vue.component('banks-list', {
    props: ['parent', 'size'],
    data: function () {
        return {
            banks: [],
            currentPage: 0,
            total: 0,
            isLoading: false
        };
    },
    methods: {
        getBanks: function () {
            var vm = this;
            vm.isLoading = true;
            $.getJSON("/umbraco/Surface/Banks/GetBanks",
                {
                    parent: this.parent,
                    page: this.currentPage,
                    size: this.size
                })
                .done(function (data) {
                    vm.banks = vm.banks.concat(data.Banks);
                    vm.currentPage++;
                    vm.total = data.Total;
                    vm.isLoading = false;
                })
                .fail(function () {
                    console.log('fail');
                    vm.isLoading = false;
                });
        }
    },
    mounted: function () {
        if (this.size && this.size > 0) {
            this.getBanks();
        }       
    }
});

<template>
    <div>
        <div class="about-layout__loyalty_partners">
            <transition-group name="fade">
                <div class="item" v-for="bank in banks" :key="bank.title">
                    <div class="item__img"><img :src="bank.logo" alt=""></div>
                    <div class="item__head">
                        <span class="title">{{bank.title}}</span>
                        <p><a :href="'tel:' + bank.phone.digits">{{bank.phone.title}}</a></p>
                        <p><a class="bank-link" :href="bank.website.url" rel="nofollow" target="_blank">{{bank.website.title}}</a></p>
                    </div>
                    <div class="item__desc">
                        <p v-html="bank.text"></p>
                    </div>
                    <div class="item__percent">
                        <span>{{bank.percent}}%</span>
                    </div>
                </div>
            </transition-group>
        </div>
        <transition name="fade" :duration="350">
            <footer class="about-layout__loyalty_foot" v-show="banks.length < total">
                <button class="button-pill lighted" :class="{loading:isLoading}" v-on:click="getBanks()">Загрузить ещё</button>
            </footer>
        </transition>
    </div>
</template>

<script>
    export default {
        props: ['parent', 'size'],
        data: function () {
            return {
                banks: [],
                currentPage: 0,
                total: 0,
                isLoading: false
            };
        },
        methods: {
            getBanks() {
                var vm = this;
                vm.isLoading = true;
                $.getJSON("/umbraco/Surface/Banks/GetBanks",
                    {
                        parent: this.parent,
                        page: this.currentPage,
                        size: this.size
                    })
                    .done(function (data) {
                        vm.banks = vm.banks.concat(data.Banks);
                        vm.currentPage++;
                        vm.total = data.Total;
                        vm.isLoading = false;
                    })
                    .fail(function () {
                        console.log('fail');
                        vm.isLoading = false;
                    });
            }
        },
        mounted: function () {
            if (this.size && this.size > 0) {
                this.getBanks();
            }       
        }
    }
</script>